import _merge from 'lodash/merge';
import _debounce from 'lodash/debounce';
import { Lightning } from '@lightningjs/sdk';
import { defaultContext, getInitialStyle, VISIBILITY_TRANSITION } from './storyboard.style';
import { BIG_FRAME_W, FRAME_H, FRAME_W, FRAME_Y, STORYBOARD_DISPLAY_DURATION } from './storyboard.constants';
import { getStoryboardGroupedFrames } from './storyboard.utils';

export default class Storyboard extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {
          type: Lightning.components.BorderComponent,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._frames = null;
    this._image = null;
    this._currentImage = null;
    this._style = defaultContext;
    this._innerFramePosition = 0;
    this._startAutoHide = _debounce(() => {
      this.setSmooth('alpha', 0, VISIBILITY_TRANSITION);
    }, STORYBOARD_DISPLAY_DURATION);
  }

  _detach() {
    this._startAutoHide.cancel();
    this._frames = null;
    this._image = null;
    this._currentImage = null;
  }

  _setVisible() {
    this._startAutoHide();
    this.setSmooth('alpha', 1, VISIBILITY_TRANSITION);
  }

  _moveTexture(shift) {
    this.texture.enableClipping(shift, FRAME_Y, FRAME_W, FRAME_H);
    this._setVisible();
  }

  _findFrameAndPosition(position) {
    this._image = this._frames[Math.floor(position / BIG_FRAME_W)];
    this._innerFramePosition = position % BIG_FRAME_W;
  }

  set imageId(id) {
    if (id) {
      this._frames = getStoryboardGroupedFrames(id);
    }
  }

  get isVisible() {
    return this.alpha === 1;
  }

  updateView(seekPosition) {
    if (this._frames && this._frames.length > 0) {
      this._findFrameAndPosition(seekPosition);

      if (!this._currentImage || this._currentImage !== this._image) {
        this._currentImage = this._image;
        this.patch({ src: this._image });
        this._moveTexture(this._innerFramePosition);

        return;
      }

      this._moveTexture(this._innerFramePosition);
    }
  }
}
